import React, { Component } from 'react';
import { CardLayout, TableLayout } from '../containers/Layout';
import { isEmpty } from 'lodash';
import { TableRow, TableHead,  TableCell, Grid, Box, TableBody, Button, Typography } from '@material-ui/core';
import SingleTemplate from '../containers/SingleTemplate';

class SingleArrivage extends Component {
    state = {
        purchase: this.props.purchase,
        shop: this.props.shop,
        src: ""
    }
    componentDidMount = () =>{
        console.log("[INFO] MOUNTING PURCHASE SINGLE ");
        const {shop, purchase} = this.props
        // if(shop.logo.filename && !shop.src){
        //     this.props.getPhoto(shop.id, shop.logo.filename)
        // }
        if( !isEmpty(purchase.purchase_files) ) {
            purchase.purchase_files.map( file => {
                console.log('====================================');
                console.log({file});
                console.log('====================================');
                this.downloadFile(file.filename)
            })
        }
    }

    createProductList(){
        const { PRODUCTS } = this.props
        return this.state.purchase.products.map( purchaseItem => {
            // const PU = parseFloat(purchaseItem.price)/parseFloat(purchaseItem.quantity)
            // const taxU = PU * parseFloat(this.state.purchase.surcout)
            // const PTTC = purchaseItem.price * parseFloat(this.state.purchase.surcout)
            return (
                <TableRow key={purchaseItem.product_id}>
                    <TableCell>{PRODUCTS[purchaseItem.product_id].name}</TableCell>
                    <TableCell>{purchaseItem.quantity}</TableCell>
                </TableRow>
            )
        })
    }
    
   
    downloadFile = async (path) => {
        try {
            const req = await fetch('/stocks/getPhotos', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({ path: path }),
                credentials: 'same-origin'
            });
            const src = await req.json();
            console.log(src);
            if (src.error) {
                console.log("[ERROR], fetching file ", src)
                return;
            }
            this.setState({
                [path]: src.uri,
            });
        } catch (err) {
            console.log("[ERROR], catch fetching file", err)
        }
    }
    
    render(){
        console.log("[PROPS] PURCHASE",this.props);
        console.log("[STATE] PURCHASE",this.state);
        const { purchase, shop } = this.state;
        return(
            // <CardLayout>
            //     <div className="pull-right">
            //         <Button color="secondary" onClick={() => window.print() }>Imprimer</Button>
            //     </div>
            //     {!isEmpty(purchase.purchase_files) &&
            //         <Box p={2}>
            //             Pièces jointes: 
            //             {purchase.purchase_files.map( (file, i) => (
            //                 <li>
            //                     <a 
            //                         title="Télécharger"
            //                         href={this.state[file.filename]} 
            //                         download={`${new Date(purchase.date).toLocaleDateString('fr-FR')}_${purchase.id.slice(0,9)}${i + 1}.${extension(file.filetype)}`} >Fichier {i+ 1}</a>
            //                 </li>
            //             ))}
            //         </Box>
            //     }
            //     <div id="section-to-print" style={{padding:"25px 15px 10px"}} >
            //         <div className="card-text" style={{margin: "20px"}}>
            //             <Grid container spacing={2}>
            //                 <Grid xs={8} >
            //                     {this.props.shop.logo &&
            //                     <div className="logo">
            //                         <img src={`/stocks/photos/${this.props.shop.logo.filename}`} alt=""/>
            //                     </div>
            //                     }
            //                     <Typography variant="subtitle1">{shop.name}</Typography>
            //                     <Box p={1}>
            //                         <h4><Typography variant="button">{(purchase.nature).toUpperCase()} du {(new Date(purchase.date)).toLocaleString('fr-FR')}</Typography></h4>
            //                     </Box>
                                
            //                     {purchase.nature === "demande" &&
            //                         <Box p={1}>
            //                             Auteur :  {purchase.user_name}
            //                         </Box>
            //                     }
            //                     <Box p={1}>
            //                         <Typography variant="subtitle2">
            //                             {purchase.comments}
            //                         </Typography>
            //                     </Box>
            //                     <br/>
            //                 </Grid>
            //             </Grid>
                        
            //             <hr/>
            //             <div>
            //                 <TableLayout>
            //                     <TableHead>
            //                         <TableRow>
            //                             <TableCell>Produit</TableCell>
            //                             <TableCell>Quantité</TableCell>
            //                             {/* <TableCell>PU HT</TableCell>
            //                             <TableCell>PU Revient</TableCell>
            //                             <TableCell>Total HT</TableCell>
            //                             <TableCell>Coût Revient</TableCell> */}
            //                         </TableRow>
            //                     </TableHead>
            //                     <TableBody>
            //                         {this.createProductList()}
            //                         <TableRow>
            //                             <TableCell colSpan={2}></TableCell>                                       
            //                         </TableRow>                                    
            //                     </TableBody>
            //                 </TableLayout>     
            //             </div>
            //         </div>
            //     </div>
            // </CardLayout>

            <SingleTemplate
                shop={shop}    
                // shopDest={shopDest}    
                sale={purchase}    
                notif={this.props.notif}
            >
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Produit</TableCell>
                            <TableCell>Quantité</TableCell>
                            {/* <TableCell>PU HT</TableCell>
                            <TableCell>PU Revient</TableCell>
                            <TableCell>Total HT</TableCell>
                            <TableCell>Coût Revient</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.createProductList()}
                        <TableRow>
                            <TableCell colSpan={2}></TableCell>                                       
                        </TableRow>                                    
                    </TableBody>
                </TableLayout>     
            </SingleTemplate>
        )
    }
}

export default SingleArrivage;